import styled from 'styled-components';
import { MainBtnLink } from 'components/Buttons';

export const ProfissionalsWrapper = styled.div`
  margin-top: 80px;
  margin-bottom: 80px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 620px;
  align-self: center;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 30px;

  h2 {
    font-size: var(--font-bigger);
    font-family: 'Inter Bold';
    margin-bottom: 15px;

    @media (max-width: 768px) {
      font-size: var(--font-largest);
    }
  }

  p {
    font-size: var(--font-medium);
  }
`;

export const Flag = styled.span`
  width: fit-content;
  color: var(--primary-color);
  background-color: var(--color-light-pink);
  border-radius: 25px;
  padding: 7px 30px;
  margin-bottom: 25px;

  img {
    width: 14px;
  }
`;

export const MainBtn = styled(MainBtnLink)`
  margin-bottom: 5px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    color: var(--primary-color);
    font-size: var(--font-small);
  }
`;
